import moment from 'moment';

export const DASHBOARD_SECTIONS = {
  attendance: 'attendance',
  requests: 'requests',
  leaves: 'leaves',
  tasks: 'tasks',
  holidays: 'holidays',
  performance: 'performance',
};

export const DEFAULT_PERFORMANCE_DAYS = 30;

export function getDefaultDashboardSection() {
  return null;
}

function countPending(items = []) {
  return items.filter((item) => String(item?.status || '').toLowerCase() === 'pending').length;
}

export function getRequestSummary({
  myRequests = [],
  myLeaveRequests = [],
  myExtraHoursRequests = [],
} = {}) {
  const allRequests = [
    ...myRequests,
    ...myLeaveRequests,
    ...myExtraHoursRequests,
  ];

  return {
    total: allRequests.length,
    pending: countPending(allRequests),
  };
}

export function getTaskSummary({
  myTasks = [],
} = {}) {
  return {
    open: myTasks.length,
    dueToday: 0,
    overdue: 0,
  };
}

function getAttendancePercent(attendanceData) {
  const summary = attendanceData?.summary || {};
  const totalDays = Number(summary.totalDays || 0);
  const presentDays = Number(
    summary.presentDays ??
    summary.rawWorkingDays ??
    summary.workingDays ??
    0
  );

  if (totalDays <= 0) {
    return '0%';
  }

  return `${Math.round((presentDays / totalDays) * 100)}%`;
}

function formatHours(value) {
  const numericValue = Number(value || 0);

  if (Number.isInteger(numericValue)) {
    return String(numericValue);
  }

  return numericValue.toFixed(1).replace(/\.0$/, '');
}

export function getHolidaysInMonth(holidays = [], monthValue = moment()) {
  const month = moment(monthValue);

  if (!month.isValid()) {
    return [];
  }

  return holidays.filter((holiday) => {
    const holidayDate = moment(holiday?.holidayDate);
    return holidayDate.isValid() && holidayDate.isSame(month, 'month');
  });
}

export function getEmployeeDashboardStats({
  attendanceData,
  myRequests = [],
  myLeaveRequests = [],
  myExtraHoursRequests = [],
  myTasks = [],
  upcomingHolidays = [],
  currentMonth = moment(),
  performanceData,
} = {}) {
  const requestSummary = getRequestSummary({
    myRequests,
    myLeaveRequests,
    myExtraHoursRequests,
  });
  const taskSummary = getTaskSummary({ myTasks });
  const totalHours = attendanceData?.summary?.totalHours || 0;
  const completedTasks = performanceData?.summary?.totalCompleted || 0;
  const currentMonthHolidays = getHolidaysInMonth(upcomingHolidays, currentMonth);

  return [
    {
      id: DASHBOARD_SECTIONS.attendance,
      label: 'Attendance',
      value: getAttendancePercent(attendanceData),
      meta: `${formatHours(totalHours)}h logged`,
    },
    {
      id: DASHBOARD_SECTIONS.requests,
      label: 'Requests',
      value: String(requestSummary.total),
      meta: `${requestSummary.pending} pending`,
    },
    {
      id: DASHBOARD_SECTIONS.leaves,
      label: 'Leaves',
      value: String(myLeaveRequests.length),
      meta: `${countPending(myLeaveRequests)} pending`,
    },
    {
      id: DASHBOARD_SECTIONS.tasks,
      label: 'Tasks',
      value: String(taskSummary.open),
      meta: `${taskSummary.dueToday} due today`,
    },
    {
      id: DASHBOARD_SECTIONS.holidays,
      label: 'Holidays',
      value: String(currentMonthHolidays.length),
      meta: 'this month',
    },
    {
      id: DASHBOARD_SECTIONS.performance,
      label: 'Performance',
      value: String(completedTasks),
      meta: 'completed',
    },
  ];
}
